import { axios } from '@/utils/request'

const api = {
  enterpriseOrderList:'/order/enterpriseOrder/list',
}

//1.1.5编辑企业模板
export function enterpriseOrderList (parameter) {
  return axios({
    // url: api.enterpriseOrderList+'?enterpriseId=a2509243bd9c11eabbbe003018a7c1db',
    url: api.enterpriseOrderList,
    method: 'get',
    params: parameter
  })
}

export function exportEnt (parameter) {
  return axios({
    url: '/order/enterpriseOrder/exportEnt ',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}